module.exports = "/_next/static/images/iphone_gray_bar-cb2a04b9076832c27751acc1455b8db2.png";